<section [ngClass]="$safeNavigationMigration(event?.eventType?.toLowerCase())" class="event_line" [id]="event.displayName + '__' + (event.plcDateTime | date:'dd-MM-yy__HH:mm:ss')">
  @if (columnIsDiplayed('plcDateTime')) {
    <div class="dateState"><span>{{ event.plcDateTime | date: dateFormat:undefined:language }}</span></div>
  }
  @if (columnIsDiplayed('tag')) {
    <div  class="tag"> <span>{{ event.displayName }}</span></div>
  }
  @if (columnIsDiplayed('message')) {
    <div class="message"> <span>{{ event.message }}</span></div>
  }
  @if (columnIsDiplayed('value')) {
    <div  class="value">
      <span>{{ event.value }}</span>
    </div>
  }
</section>
